import { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Swal from "sweetalert2";
import {
  compneyState,
  compneyStateMange,
  createCompanyDetails,
  updateCompanyDetails,
} from "./compenyData";
import { useMutation } from "@apollo/client";
import { useLoading } from "../../../context/LodingContext";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import ImageSelector from "../../components/ImageSelector";
import MaterialButton from "../../../components/MaterialButton";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";

const CompenyMasterForm = () => {
  const [compneyData, dispatch] = useReducer(compneyStateMange, compneyState);
  const [inputDisble, setInputDisble] = useState(false);
  const [createCompney] = useMutation(createCompanyDetails);
  const [UpdateCompney] = useMutation(updateCompanyDetails);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();

  const formType = location?.state?.type;
  const formValue = location?.state?.data;

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      compneyData.companyNameStatus === "success" &&
      compneyData.registrationNumberStatus === "success" &&
      compneyData.addressStatus === "success" &&
      compneyData.contactNumberStatus === "success" &&
      compneyData.fiscalYearStatus === "success" &&
      compneyData.currencyStatus === "success" &&
      compneyData.dateFormatStatus === "success" &&
      compneyData.companyLogoStatus
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.companyName,
        name: "companyName",
      });
      dispatch({
        value: formValue?.registrationNumber,
        name: "registrationNumber",
      });
      dispatch({
        value: formValue?.address,
        name: "address",
      });
      dispatch({
        value: formValue?.contactNumber,
        name: "contactNumber",
      });
      dispatch({
        value: formValue?.fiscalYear,
        name: "fiscalYear",
      });
      dispatch({
        value: formValue?.currency,
        name: "currency",
      });
      dispatch({
        value: formValue?.dateFormat,
        name: "dateFormat",
      });
      // dispatch({
      //   value: formValue?.companyLogo,
      //   name: "companyLogo",
      // });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "companyLogo" });
  };

  const handleAddCompany = async () => {
    setCirleLoading(true);

    try {
      const response = await createCompney({
        variables: {
          input: {
            user: userId,

            companyName: compneyData?.companyName,

            registrationNumber: compneyData?.registrationNumber,

            address: compneyData?.address,

            contactNumber: compneyData?.contactNumber,

            fiscalYear: compneyData?.fiscalYear,

            currency: compneyData?.currency,

            dateFormat: compneyData?.dateFormat,

            companyLogo: compneyData?.companyLogo,
          },
        },
        context: { hasUpload: true },
      });
      const success = response?.data?.createCompanyDetails?.success;
      const message = response?.data?.createCompanyDetails?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/company-master");
          window.location.reload();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };
  const handleupdateCompany = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateCompney({
        variables: {
          input: {
            id: formValue?.id,
            companyName: compneyData?.companyName,

            registrationNumber: compneyData?.registrationNumber,

            address: compneyData?.address,

            contactNumber: compneyData?.contactNumber,

            fiscalYear: compneyData?.fiscalYear,

            currency: compneyData?.currency,

            dateFormat: compneyData?.dateFormat,
            companyLogo: compneyData?.companyLogo?.name
              ? compneyData.companyLogo
              : null,
          },
        },
        context: { hasUpload: true },
      });
      const success = response?.data?.updateCompanyDetails?.success;
      const message = response?.data?.updateCompanyDetails?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/company-master");
          window.location.reload();
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Company Details"
                    : formType == "edit"
                    ? "Edit Company Details"
                    : "View Company Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Company Name
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.companyName}
                  name="companyName"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "companyName" })
                  }
                  error={
                    compneyData.companyNameStatus === "error" ? true : false
                  }
                  success={
                    compneyData.companyNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Registration Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.registrationNumber}
                  name="registrationNumber"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "registrationNumber",
                    })
                  }
                  error={
                    compneyData.registrationNumberStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    compneyData.registrationNumberStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Number
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.contactNumber}
                  name="contactNumber"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "contactNumber",
                    })
                  }
                  error={
                    compneyData.contactNumberStatus === "error" ? true : false
                  }
                  success={
                    compneyData.contactNumberStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Fiscal Year
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.fiscalYear}
                  name="fiscalYear"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "fiscalYear",
                    })
                  }
                  error={
                    compneyData.fiscalYearStatus === "error" ? true : false
                  }
                  success={
                    compneyData.fiscalYearStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Currency
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.currency}
                  name="currency"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "currency",
                    })
                  }
                  error={compneyData.currencyStatus === "error" ? true : false}
                  success={
                    compneyData.currencyStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 4, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date Format
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={compneyData?.dateFormat}
                  type="date"
                  name="dateFormat"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "dateFormat",
                    })
                  }
                  error={
                    compneyData.dateFormatStatus === "error" ? true : false
                  }
                  success={
                    compneyData.dateFormatStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Address
                  </MaterialTypography>
                </MaterialBox>

                <MaterialInput
                  multiline
                  rows={5}
                  value={compneyData?.address}
                  name="address"
                  placeholder="Enter Address"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "address" })
                  }
                  error={compneyData.addressStatus === "error" ? true : false}
                  success={
                    compneyData.addressStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Company Image
                  </MaterialTypography>
                </MaterialBox>

                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={formValue?.companyLogo}
                  disabled={inputDisble}
                  isDelete={false}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/company-master")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkAllFields()}
                onClick={
                  formType == "add" ? handleAddCompany : handleupdateCompany
                }
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default CompenyMasterForm;
